import Registrations from './registrations'
export default Registrations
